<!-- Orbi MyLabcorp Pass card (PCSA-13374). Mirrors mobile's compact
     LabcorpPatientPassCard: title, one instructional line, the QR image built
     from the agent's encrypted lpid, and the add-to-wallet action for whichever
     wallet the device has. Rendered only when a QR URL could be built (no lpid
     means nothing to scan). -->
<section *ngIf="hasPass" class="orbi-patient-pass-card" aria-label="MyLabcorp Pass">
  <div class="orbi-patient-pass-card__card">
    <div class="orbi-patient-pass-card__head">
      <span class="material-icons-round orbi-patient-pass-card__icon" aria-hidden="true">qr_code_2</span>
      <h3 class="orbi-patient-pass-card__title">{{ title }}</h3>
    </div>

    <p class="orbi-patient-pass-card__instructions">{{ instructions }}</p>

    <!-- QR + wallet badge are ONE centered group (Figma): side by side while the
         panel is wide enough, wrapping to stacked-and-centered when it is not.
         Both Figma variants of this card are that single flex row at two widths. -->
    <div class="orbi-patient-pass-card__pass">
      <img [src]="qrCodeUrl" class="orbi-patient-pass-card__qr" alt="MyLabcorp Pass QR code" width="155" height="155" />

      <!-- The platforms' official badge artwork, not text buttons — the same
           assets + srcsets the portal's Labcorp ID page uses, at their native
           sizes. A badge is shown whenever a pass rendered: without a confirmation
           number the control falls back to the authenticated `/me/pass` endpoint
           rather than disappearing (see `ngOnChanges`).

           WHICH badge follows the device (design review 08/20) — Apple on Apple
           platforms, Google on Android, and BOTH where the user agent cannot say,
           which is every Windows/Linux desktop. Apple stays first so the pair
           reads in the same order as the portal page's. -->
      <div class="orbi-patient-pass-card__wallets">
        <button
          *ngIf="showAppleWallet"
          type="button"
          class="orbi-patient-pass-card__wallet orbi-patient-pass-card__wallet--apple"
          [disabled]="isDownloadingWalletPass"
          [attr.aria-label]="appleWalletLabel"
          (click)="onAddToWallet('apple')"
        >
          <img
            srcset="assets/appointments/add-to-apple-wallet@2x.png 2x, assets/appointments/add-to-apple-wallet@3x.png 3x"
            src="assets/appointments/add-to-apple-wallet.png"
            class="orbi-patient-pass-card__wallet-badge"
            width="153"
            height="48"
            alt=""
          />
        </button>

        <button
          *ngIf="showGoogleWallet"
          type="button"
          class="orbi-patient-pass-card__wallet orbi-patient-pass-card__wallet--google"
          [disabled]="isDownloadingWalletPass"
          [attr.aria-label]="googleWalletLabel"
          (click)="onAddToWallet('google')"
        >
          <img
            srcset="assets/appointments/add-to-google-wallet@2x.png 2x, assets/appointments/add-to-google-wallet@3x.png 3x"
            src="assets/appointments/add-to-google-wallet.png"
            class="orbi-patient-pass-card__wallet-badge orbi-patient-pass-card__wallet-badge--google"
            width="175"
            height="48"
            alt=""
          />
        </button>
      </div>
    </div>

    <!-- Inline failure notice (authenticated path only, in practice): a download
         that fails must say so rather than looking like a dead badge. `role=alert`
         so it is announced; the badge stays enabled for a retry. -->
    <p *ngIf="walletFailed" class="orbi-patient-pass-card__error" role="alert">{{ walletErrorText }}</p>
  </div>
</section>
